import { render } from "./ContentEditable.vue?vue&type=template&id=1b15b212&scoped=true"
import script from "./ContentEditable.vue?vue&type=script&lang=js"
export * from "./ContentEditable.vue?vue&type=script&lang=js"

import "./ContentEditable.vue?vue&type=style&index=0&id=1b15b212&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b15b212"]])

export default __exports__